import { getPartnerPaymentDetails } from '@atlassian/mpac-api-client';
import { useTwoStepVerifiedAsync } from '@atlassian/mpac-ui';
import { log } from '@atlassian/mpac-utils';
import { useCallback } from 'react';
export const usePartnerPaymentDetails = (mpacBaseUrl, partnerId) => {
  const promiseFn = useCallback((_, _ref) => {
    let {
      signal
    } = _ref;
    return getPartnerPaymentDetails(mpacBaseUrl, partnerId, {
      signal
    });
  }, [mpacBaseUrl, partnerId]);
  const {
    isPending,
    isRejected,
    data,
    error,
    reload,
    cancel
  } = useTwoStepVerifiedAsync({
    promiseFn
  });
  if (isRejected) {
    log.error('PartnerPaymentDetails/hooks', "Failed to retrieve payment details", {
      error
    });
  }
  return {
    isPaymentDetailsPending: isPending,
    isPaymentDetailsRejected: isRejected,
    paymentDetailsError: error,
    paymentDetails: data,
    reloadPaymentDetails: reload,
    cancelPendingPaymentDetails: cancel
  };
};